import { Component, ElementRef, HostListener, OnInit, QueryList, ViewChildren } from '@angular/core';
import { WorkOrderStatus } from '../../business-entities/appointmentStatus-model';
import { DealerViewModel } from '../../business-entities/dealer-view-model';
import * as Enums from '../../../../../Autofacets-Core/src/app/utils/enums';
import { NgbdSortableHeader, SortEvent } from 'projects/Autofacets-Core/src/app/directives/sortable.directive';
import { PagerData } from '../../business-entities/PagerData';
import { Constant } from 'projects/Autofacets-Core/src/app/utils/constant';
import { Utility } from 'projects/Autofacets-Core/src/app/utils/utility';
import { ModalDismissReasons, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { TranslateService } from '@ngx-translate/core';
import { NgbdModalContent } from 'projects/Autofacets-Core/src/app/shared/delete-modal.component';
import { NgxSpinnerService } from 'ngx-spinner';
import { AppointmentService } from '../../business-services/appointment.service';
import { AppointmentLockedModel } from '../../business-entities/appointment-locked-model';
import { jsPDF } from 'jspdf';
import autoTable from 'jspdf-autotable';
import { ExcelService } from 'projects/Autofacets-Core/src/app/common-services/export-excel.service';
import { DatePipe } from '@angular/common';
import { GlobalSetting } from 'projects/Autofacets-Core/src/app/common-services/global-setting.service';
import { SecureStorage } from 'projects/Autofacets-Core/src/app/common-services/SecureStorage.service';
import { ToastrService } from 'ngx-toastr';
import { UserRoleMenu } from '../../business-entities/user-role-menu.model';
import { UserDataService } from '../../../../../../src/app/DataServices/user-data.service';
import { AdminCommonService } from '../../services/admin-common.service';
import { BsDaterangepickerConfig } from 'ngx-bootstrap/datepicker';


@Component({
  selector: 'app-appointment-locking',
  templateUrl: './appointment-locking.component.html',
})
export class AppointmentLockingComponent implements OnInit {

  //#region Declaration
  searchTerm: string;
  totalCount: number = 0;
  isAdvanceSearch: boolean = false;
  dealerList: DealerViewModel[];
  AppointmentLockList: AppointmentLockedModel[] = [];
  workOrderStatusList: WorkOrderStatus[];
  selectedStatus: number;
  isTodayViewOn: boolean;
  myDateRangePickerOptions: Partial<BsDaterangepickerConfig> = Object.assign({},{
    containerClass: 'theme-dark-blue',
    displayMonths:1,
    showWeekNumbers:false,
    rangeInputFormat: 'DD/MM/YYYY',
    customTodayClass: 'custom-today-class'
  });
  popupCloseResult = false;
  isWeekViewOn: boolean;
  lockedOnDate: any[] = [];
  unlockedOnDate: any[] = [];
  weekViewDate: any;
  todayViewDate: any;
  LockedAppointmentResponse: AppointmentLockedModel[] = [];
  throttle = 100;
  scrollDistance = 1;
  pager: any = {};
  pagerData: PagerData = {
    page: 1,
    pagerSize: Constant.GridPagerSize,
  };
  AppointmentLockListPdf: any;
  LockedDate: any = null;
  UnLockedDate: any = null;
  AppointmentLockExcel: any;
  LockedAppointmentData = {
    sortColumn: '',
    sortDirection: '',
    StartRecordNumber: 0,
    PageSize: 25,
    Lockedon: null,
    UnLockedon: null,
    LanguageCode: '',
    LockedBy: '',
    WorkOrderNo: '',
    LockedDate: '',
    UnLockedDate: '',
    SearchTerm: '',
    IsForList: false
  }
  userRoleRightsDetails: UserRoleMenu;
  @ViewChildren(NgbdSortableHeader) headers: QueryList<NgbdSortableHeader>;
  //#endregion

  //#region Constructor & OnInit
  constructor(private modalService: NgbModal,
    private translate: TranslateService,
    private spinner: NgxSpinnerService,
    private excelService: ExcelService,
    private datePipe: DatePipe,
    private _eref: ElementRef,
    private globalSetting: GlobalSetting,
    private secureStorage: SecureStorage,
    private toastr: ToastrService,
    private appointmentService: AppointmentService,
    private userService: UserDataService,
    private adminCommonSer :AdminCommonService
  ) {
  }
  ngOnInit(): void {
    this.userRoleRightsDetails = (this.userService.currentUserValue.userRoleMenuDetails as any[]).find(menu => menu.moduleId === Enums.ModuleNames.AppointmentLock);
    this.getLockedAppointment();
    if (this.LockedAppointmentData.Lockedon) {
      if (this.appointmentService.dateFlag === 1) {
        let date_format = new Date(new Date().setDate(new Date().getDate() + 1));
        this.lockedOnDate=[];
        this.lockedOnDate.push(date_format);
        this.lockedOnDate.push(date_format);
      }
      else {
        let date_format = new Date();
        this.lockedOnDate=[];
        this.lockedOnDate.push(date_format);
        this.lockedOnDate.push(date_format);
      }
    }

    if (this.LockedAppointmentData.UnLockedon) {
      if (this.appointmentService.dateFlag === 1) {
        let date_format = new Date(new Date().setDate(new Date().getDate() + 1));
        this.unlockedOnDate=[];
        this.unlockedOnDate.push(date_format);
        this.unlockedOnDate.push(date_format);
      }
      else {
        let date_format = new Date();
        this.unlockedOnDate=[];
        this.unlockedOnDate.push(date_format);
        this.unlockedOnDate.push(date_format);
      }
    }

    if (this.appointmentService.filterTypeId == Constant.TodayView) {
      this.loadTodayView();
    } else if (this.appointmentService.filterTypeId == Constant.WeekView) {
      this.loadWeekView();
    }
    else {
      this.LockedAppointmentData.Lockedon = null;
    }
  }
  //#endregion

  //#region Page Methods
  onClose() {
    this.onReset();
    this.isAdvanceSearch = false;
  }
  AdvanceSearchSubmit() {
    let lockedOnDateFormatted= this.getFormattedDate(this.lockedOnDate);
    let unlockedOnDateFormatted= this.getFormattedDate(this.unlockedOnDate);
    this.LockedAppointmentData.SearchTerm = this.LockedAppointmentData.WorkOrderNo;
    this.LockedAppointmentData.Lockedon = lockedOnDateFormatted;
    this.LockedAppointmentData.UnLockedon = unlockedOnDateFormatted;
    this.spinner.show();
    this.LockedAppointmentResponse = [];
    this.getLockedAppointment();
    this.isAdvanceSearch = false;
  }
  onSearch() {
    this.isAdvanceSearch = true;
  }
  @HostListener('document:click', ['$event'])
  onSearchBoxClose(event) {
    if (event) {
      if (!this._eref.nativeElement.getElementsByClassName('advanced-search-box')[0]?.contains(event.target)) {
        this.isAdvanceSearch = false;
      }
    }
  }
  onQuickSerch() {
    this.LockedAppointmentData.SearchTerm = this.searchTerm;
    this.spinner.show();
    this.LockedAppointmentResponse = [];
    this.getLockedAppointment();
  }
  onScrollDown(_ev) {
    if (this.totalCount > this.LockedAppointmentResponse.length) {
      this.LockedAppointmentData.StartRecordNumber = this.LockedAppointmentResponse.length
      this.getLockedAppointment();
    }
  }
  onClickChangeView(isWeek: boolean) {
    if (isWeek) {
      this.loadWeekView();
    } else {
      this.loadTodayView();
    }
  }
  loadWeekView() {
    this.isTodayViewOn = false;
    this.isWeekViewOn = true;
    const { weekViewDate, bookingDate } = this.adminCommonSer.getWeekViewDates(1);
    this.LockedDate = {... bookingDate};
    this.LockedAppointmentData.Lockedon =weekViewDate;
    this.spinner.show();
    this.LockedAppointmentResponse = [];
    this.getLockedAppointment();
  }
  loadTodayView() {
    this.isTodayViewOn = true;
    this.isWeekViewOn = false;
    let todays_date = new Date();
    this.weekViewDate = this.datePipe.transform(todays_date, 'dd/MM/yyyy') + ' - ' + this.datePipe.transform(todays_date, 'dd/MM/yyyy');
    this.LockedDate = {
      beginDate: { year: todays_date.getFullYear(), month: todays_date.getMonth() + 1, day: todays_date.getDate() },
      endDate: { year: todays_date.getFullYear(), month: todays_date.getMonth() + 1, day: todays_date.getDate() },
      formatted: this.weekViewDate
    };
    this.todayViewDate = this.datePipe.transform(new Date(), 'dd/MM/yyyy') + ' - ' + this.datePipe.transform(new Date(), 'dd/MM/yyyy');
    this.LockedAppointmentData.Lockedon = this.todayViewDate;
    this.LockedAppointmentData.StartRecordNumber = 0;
    this.AppointmentLockList = [];
    this.spinner.show();
    setTimeout(() => {
      this.spinner.hide();
    }, 3000);
    this.LockedAppointmentResponse = [];
    this.getLockedAppointment();
  }
  exportAsXLSX(_excel: number) {
    this.spinner.show();
    this.AppointmentLockExcel = this.AppointmentLockExcelDataMapper(this.LockedAppointmentResponse);
    this.spinner.hide();
    this.excelService.exportAsExcelFile(this.AppointmentLockExcel, 'AppointmentLock_af');
  }
  private AppointmentLockExcelDataMapper(List: any) {
    let supperArray = [];
    if (List && List.length > 0) {
      for (let index = 0; index < List.length; index++) {
        const element = List[index];
        let single = Object();
        single.No = index + 1;
        single.woNumber = element.workorderNo;
        single.lockedBy = element.lockedByName;
        single.lockedOn = element.unlockedByName;
        single.lockedDate = element.lockedOn;
        single.unlockedDate = element.unlockedOn;
        supperArray.push(single);
      }
    }
    return supperArray;
  }
  onDownloadPDF(_pdf: number) {
    this.spinner.show();
    this.AppointmentLockListPdf = this.LockedAppointmentResponse;
    setTimeout(() => {
      const doc = new jsPDF();
      autoTable(doc, { html: '#lockappointment', margin: { top: 3, left: 3, right: 3, bottom: 3 }, styles: { fontSize: 8 } });
      doc.save('Appointment-Lock-List.pdf');
      this.spinner.hide();
    }, 100)
  }
  public get documentTypes(): typeof Enums.DocumentsType {
    return Enums.DocumentsType;
  }
  refresh() {
    this.LockedAppointmentData.StartRecordNumber = 0;
    this.LockedAppointmentData.SearchTerm = null;
    this.LockedAppointmentData.Lockedon = null;
    this.lockedOnDate = [];
    this.LockedAppointmentResponse = [];
    this.getLockedAppointment();
  }
  onSort({ column, direction }: SortEvent) {
    this.headers.forEach(header => {
      if (header.sortable !== column) {
        header.direction = '';
      }
    });
    this.LockedAppointmentData.sortColumn = column;
    this.LockedAppointmentData.sortDirection = direction;
    this.LockedAppointmentData.StartRecordNumber = 0;
    this.spinner.show();
    this.LockedAppointmentResponse = [];
    this.getLockedAppointment();
  }
  async setPage(pagerData: PagerData) {
    if (
      pagerData == null ||
      pagerData === undefined ||
      pagerData.page < 1 ||
      pagerData.page > this.pager.totalPages
    ) {
      return;
    }
    this.pagerData.page = pagerData.page;
    this.pagerData.pagerSize = pagerData.pagerSize;
  }
  onReset() {
    this.LockedAppointmentData.WorkOrderNo = null;
    this.lockedOnDate = [];
    this.unlockedOnDate = [];
    this.LockedAppointmentData.StartRecordNumber = 0;
  }
  private getDismissReason(reason: any): boolean {
    if (reason === ModalDismissReasons.ESC) {
      return false;
    } else if (reason === ModalDismissReasons.BACKDROP_CLICK) {
      return false;
    } else {
      return reason;
    }
  }
  getLocalDate(date){
    return Utility.ConvertUTCDateToLocalDate(date);
  }
  //#endregion

  //#region Api Methods
  UnlockAppointment(lockData: any) {
    let modelHeadermsg = this.translate.instant("lblUnlock");
    let modelBodymsg = Utility.createMessage(this.translate.instant("lblSureUnlock"), this.translate.instant("lblAppointment"), true);
    const modalRef = this.modalService.open(NgbdModalContent);
    modalRef.componentInstance.modelHeader = modelHeadermsg;
    modalRef.componentInstance.modelBody = modelBodymsg;
    modalRef.result.then((_result) => { 
      // This is intentional
    }, (reason) => {
      this.popupCloseResult = this.getDismissReason(reason);
      if (this.popupCloseResult) {
        let model = {
          lockId: lockData.lockId,
          appointmentGuid: lockData.appointmentGuid
        }
        this.appointmentService.UnlockAppointment(model).then(() =>{
          let msg = this.translate.instant("lblAppointmentUnlockMsg");
            this.toastr.success(msg);
            this.refresh();
        })
        this.globalSetting.signalrConnection.subscribe(
          (connection)=>{
            if (connection) {
              const userData = this.secureStorage.getKeyData(Enums.SecureStorageKey.GetUserDetails);

              let model = {
                Id: lockData.lockId,
                UserName: userData.name,
                LockConnectionId: lockData.lockConnectionId,
                UnlockedBy: userData.userId,
                LockConnectionToken: connection.connectionId,
              }
              connection.invoke(Enums.SignalRHubMethod.UnlockAppointmentLock, model).then(()=>{
               
              });
            }
          }
        ).unsubscribe();
      }
    });
  }
  async getLockedAppointment() {
    this.spinner.show();
    this.appointmentService.GetLockedAppointmentList(this.LockedAppointmentData).then(
      (res) => {
        if (res?.responseObject) {
          this.totalCount = 0;
          this.LockedAppointmentResponse.push(...res.responseObject)
          if (this.LockedAppointmentResponse.length > 0) {
            this.totalCount = this.LockedAppointmentResponse[0].totalCount;
          }
        }
      }
    ).finally(() => {
      this.spinner.hide();
    });
  }
  //#endregion
  getFormattedDate(dateRangeArray: any[]){
    let formattedDate: string= "";
    if(dateRangeArray.length != 0){
      let beginDate= this.datePipe.transform(dateRangeArray[0], 'dd/MM/yyyy');
      let lastDate= this.datePipe.transform(dateRangeArray[1], 'dd/MM/yyyy');
      formattedDate= beginDate + ' - ' + lastDate;
    }
    return formattedDate;
  }
}

